import styled from 'styled-components';

import { MOBILE_PADDING, SCREEN_LOCKUP_WIDTH, BLACK, WHITE, PAGE_WIDTH } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

const CELL_SIZE = 190;

export const Section = styled.section`
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 4em ${MOBILE_PADDING}px;
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  margin: 0 auto;
  overflow: hidden;

  ${media.tabletL`
    padding: 0 0 6em;
  `};
`;

export const SectionInner = styled.div`
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto;
`;

export const List = styled.div`
  min-height: 400px;
  display: none;

  ${media.tabletL`
    display: block;
  `};
`;

export const SliderWrapper = styled.div`
  display: block;
  width: 100%;
  margin: 0 auto;

  & > div > div {
    width: 100%;
    overflow: visible !important;
  }

  ${media.tabletL`
    display: none;
  `};
`;

export const Item = styled.div`
  display: flex;
  color: ${WHITE};
  background-color: ${BLACK};
  min-height: ${CELL_SIZE}px;
  margin-bottom: 1em;
  padding: 20px 10%;

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  > h2 {
    margin: 0 0 20px;
    font-size: 26px;
    line-height: 1.1em;
    letter-spacing: 1px;
    max-width: 354px;

    > span {
      text-transform: uppercase;
    }

    ${media.tabletL`
      font-size: 38px;
    `};
  }

  > p {
    font-size: 14px;
    line-height: 1.5em;
    letter-spacing: 0.5px;
    flex: 1;
    max-width: 354px;
    margin: 0;

    > span {
      font-weight: 400;
    }

    ${media.tabletL`
      font-size: 16px;
      line-height: 1.1em;
    `};
  }
`;

export const SeminarTitle = styled.h4`
  font-weight: 400;
  font-size: 26px;
  text-transform: uppercase;
  margin: 0 0 1em;
  max-width: 230px;
  color: ${WHITE};

  ${media.tabletL`
    font-size: 29px;
    margin: 0;
  `};
`;

export const Keys = styled.div`
  flex: 1;
  margin-right: 2.5em;

  p {
    margin: 0;
    font-size: 14px;

    :last-child {
      line-height: 1em;
    }

    ${media.tabletL`
      font-size: 18px;
    `};

    :not(:last-child) {
      margin: 0 0 0.6em;
    }
  }
`;

export const Values = styled.div`
  flex: 3;

  p {
    margin: 0;
    font-size: 14px;

    :last-child {
      line-height: 1em;
    }

    ${media.tabletL`
      font-size: 18px;
    `};

    :not(:last-child) {
      margin: 0 0 0.6em;
    }
  }
`;

export const Title = styled.h5`
  position: relative;
  text-transform: uppercase;
  margin: 0;
  padding-bottom: 60px;
  letter-spacing: 0.1em;
  text-align: center;
  color: ${BLACK};

  &::after {
    content: '';
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BLACK};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    margin-bottom: 35px;
  `};
`;

export const SeminarLink = styled.div`
  text-align: right;

  > span {
    text-transform: uppercase;
    text-decoration: underline;
    font-weight: 800;
    font-size: 13px;
    letter-spacing: 1px;
  }
`;

export const ItemContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    flex: 2;

    :last-child {
      flex: 1;
    }
  }
`;

export const InfoList = styled.div`
  font-weight: 400;
  display: flex;

  span {
    font-weight: 400;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/RecommendedSeminars/RecommendedSeminars.style.js